module.exports = __webpack_public_path__ + "static/media/dsc_1512-copia.dc504dbe.jpg";